const RADIUS = '16px';

export const BORDER_RADIUS = {
  ALL: RADIUS,
  NONE: '0',
  TOP: `${RADIUS} ${RADIUS} 0 0`,
  BOTTOM: `0 0 ${RADIUS} ${RADIUS}`,
  LEFT: `${RADIUS} 0 0 ${RADIUS}`,
  RIGHT: `0 ${RADIUS} ${RADIUS} 0`,
  TOP_RIGHT: `0 ${RADIUS} 0 0`,
  BOTTOM_RIGHT: `0 0 ${RADIUS} 0`,
  BOTTOM_LEFT: `0 0 0 ${RADIUS}`,
} as const;

export const getFirstColumnCornerRadius = (
  index: number,
  smallImageCount: number,
  mapExpanded?: boolean
): string[] | undefined => {
  const hasSecondColumn = smallImageCount > 2 && !mapExpanded;

  if (smallImageCount === 1) {
    return [BORDER_RADIUS.NONE, BORDER_RADIUS.RIGHT, BORDER_RADIUS.RIGHT, BORDER_RADIUS.RIGHT];
  }
  if (index === 0) {
    return [
      BORDER_RADIUS.NONE,
      BORDER_RADIUS.TOP_RIGHT,
      hasSecondColumn ? BORDER_RADIUS.NONE : BORDER_RADIUS.TOP_RIGHT,
      hasSecondColumn ? BORDER_RADIUS.NONE : BORDER_RADIUS.TOP_RIGHT,
    ];
  }
  if (index === 1) {
    return [
      BORDER_RADIUS.NONE,
      BORDER_RADIUS.BOTTOM_RIGHT,
      hasSecondColumn ? BORDER_RADIUS.NONE : BORDER_RADIUS.BOTTOM_RIGHT,
      hasSecondColumn ? BORDER_RADIUS.NONE : BORDER_RADIUS.BOTTOM_RIGHT,
    ];
  }
  return undefined;
};

export const getSecondColumnCornerRadius = (index: number): string | undefined => {
  if (index === 0) return BORDER_RADIUS.TOP_RIGHT;
  if (index === 1) return BORDER_RADIUS.BOTTOM_RIGHT;
  return undefined;
};

export const getTwoImageCornerRadius = (index: number): string[] => {
  if (index === 0)
    return [BORDER_RADIUS.ALL, BORDER_RADIUS.LEFT, BORDER_RADIUS.LEFT, BORDER_RADIUS.LEFT];
  return [BORDER_RADIUS.RIGHT, BORDER_RADIUS.RIGHT, BORDER_RADIUS.RIGHT, BORDER_RADIUS.RIGHT];
};

export const getFourImageCornerRadius = (
  position: 'top' | 'bottom' | 'bottom-left' | 'bottom-right'
): string => {
  switch (position) {
    case 'top':
      return BORDER_RADIUS.TOP_RIGHT;
    case 'bottom':
      return BORDER_RADIUS.BOTTOM_RIGHT;
    case 'bottom-left':
      return BORDER_RADIUS.NONE;
    case 'bottom-right':
    default:
      return BORDER_RADIUS.BOTTOM_RIGHT;
  }
};
